import React, { useEffect, useRef, useState } from "react";
import { Canvas, useLoader } from "@react-three/fiber";
import { PerspectiveCamera } from "@react-three/drei";
import { STLLoader } from "three/examples/jsm/loaders/STLLoader";
import { PLYLoader } from "three/examples/jsm/loaders/PLYLoader";
import * as THREE from "three";
import { ErrorBoundary } from "react-error-boundary";
import { Alert, Grid } from "@mui/material";
import Carousel from "react-material-ui-carousel";
import { extend } from "@react-three/fiber";
import { useThree, useFrame } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
const STL = ({ fileType, link, customRef, offSetX, offSetXForNextStl }) => {
  let loader = null;
  if (fileType === "stl") {
    loader = STLLoader;
  } else {
    loader = PLYLoader;
  }
  const stl = useLoader(loader, link);

  if (!stl) return null;

  // compute bounding box for the STL geometry
  stl.computeBoundingBox();
  const center = stl.boundingBox.getCenter(new THREE.Vector3());
  // compute for zoom
  const size = stl.boundingBox.getSize(new THREE.Vector3());
  const maxDim = Math.max(size.x, size.y, size.z);
  const fov = 50 * (Math.PI / 180);
  let cameraZ = Math.abs((maxDim / 4) * Math.tan(fov * 2));
  cameraZ *= 1.25; // zoom out

  console.log(size);

  return (
    <>
      <PerspectiveCamera
        makeDefault
        aspect={1.777777777}
        position={[0, 0, cameraZ]}
        near={10}
        far={123}
        fov={50}
      />
      <mesh
        ref={customRef}
        position={[-2.77 + offSetX + offSetXForNextStl, -center.y, -center.z]}
        scale={[1, 1, 1]}
      >
        <primitive object={stl} />
        <meshPhongMaterial specular={0x111111} color="#CD8658" shininess={5} />
      </mesh>
    </>
  );
};

const StlMultiplePreview = ({ links, offSetXForNextStl }) => {
  let offSetX = 200;

  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorLoadingSTL}>
        <div style={{ width: "100%", height: "64vh" }}>
          <Canvas style={{ borderRadius: "inherit" }}>
            <color attach="background" args={["#FFFFFF"]} />
            <hemisphereLight skyColor={0x123445} groundColor={0x123445} />
            {/* <directionalLight position={[-30, -1, -1]} intensity={0.7} />
          <directionalLight position={[30, 1, -1]} intensity={0.7} />
          <directionalLight position={[1, 30, 1]} intensity={0.3} />
          <directionalLight position={[1, -30, 1]} intensity={0.3} />
          <directionalLight position={[1, 1, -30]} intensity={0.7} />
          <directionalLight position={[1, 1, 30]} intensity={0.3} /> 
          <directionalLight position={[0, 50, 100]} intensity={1} color={0xffffff}  />
          */}
          <directionalLight position={[-10, 10, 10]} intensity={0.6} color={0xFFFFFF} castShadow={true}  />
          <directionalLight position={[-10, 10, 10]} intensity={0.3} color={0xF1E5AC} castShadow={false}  />

          <directionalLight position={[10, 10, 10]} intensity={0.6} color={0xFFFFFF} castShadow={true}  />
          <directionalLight position={[10, 10, 10]} intensity={0.3} color={0xF1E5AC} castShadow={false}  />

          <directionalLight position={[-10, -10, 10]} intensity={0.6} color={0xFFFFFF} castShadow={true}  />
          <directionalLight position={[-10, -10, 10]} intensity={0.3} color={0xF1E5AC} castShadow={false}  />

          <directionalLight position={[10, -10, 10]} intensity={0.6} color={0xFFFFFF} castShadow={true}  />
          <directionalLight position={[10, -10, 10]} intensity={0.3} color={0xF1E5AC} castShadow={false}  />
            {links.map((link) => {
              return (
                <STL
                  fileType={link.fileType}
                  link={link.url}
                  offSetX={(offSetX -= 200)}
                  offSetXForNextStl={offSetXForNextStl}
                />
              );
            })}
            <OrbitControls
              enableZoom={true} // highlight-line
            />
            {/* <Environment background preset="sunset" blur={0.7} /> */}
          </Canvas>
        </div>
      </ErrorBoundary>
    </>
  );
};

const ErrorLoadingSTL = ({ error, resetErrorBoundary }) => {
  return (
    <Grid container>
      <Grid item>
        <Alert severity="warning" sx={{ maxWidth: "600px" }}>
          Something went wrong on the STL preview. Please download the file to
          view it.
        </Alert>
      </Grid>
    </Grid>
  );
};

export default StlMultiplePreview;
